// Legacy code, just modularized

import $ from 'jquery';
import Mustache from 'mustache';

const serviceList = {

  init: function() {
    if($('.custom-select-title').length > 0) {

      // Close main services dropdown menu when clicked outside
      const mainServicesSelect = document.getElementById('main-services-select')
      document.addEventListener('click', function(e) {
        const target = e.target
        const isChild = mainServicesSelect.contains(target)
        if (e.target !== mainServicesSelect && !isChild ) {
          mainServicesSelect.querySelector('.custom-select-content').classList.remove('show');
        }
      })

      $('.custom-select .close').on('click',function(e) {
        $(this).closest('.custom-select-content').removeClass('show');
      });

      $('.custom-select-title').on('click',function(e) {
        e.preventDefault();
        var content = $(this).parent().find('.custom-select-content');

        if(content.hasClass('show')) {
          $(this).parent().parent().find('.arrow').removeClass('open');
          $(this).parent().parent().find('.custom-select-content').removeClass('show');
        } else {
          $(this).parent().parent().find('.arrow').addClass('open');
          $(this).parent().parent().find('.custom-select-content').addClass('show');
        }
      });

      var currentCb = '';

      $('.custom-radiobuttons input').on('click',function() {

        if(currentCb === $(this).attr('id')) {
          $(this).prop('checked', false );
          currentCb = '';
        } else {
          currentCb = $(this).attr('id');
        }
        refreshServiceList();
      });

      $('.custom-checkboxes input').on('change',function() {
        refreshServiceList();
      });

    }

    function refreshServiceList() {

      var checkedService = [];
      const relatedServicesContainer = document.getElementById('related-services-container')
      //Chosen services
      $('.custom-checkboxes input').each(function() {
        if($(this).is(':checked'))
          checkedService.push($(this).val());
      });

      if (relatedServicesContainer && checkedService.length > 0 ) {
        relatedServicesContainer.classList.remove('hidden')
      } else {
        relatedServicesContainer.classList.add('hidden')
      }


      $('.select-service').text(checkedService.length);

      //Hide then show card items according to selections
      $('.cards .card').each(function(index) {
        $(this).parent().addClass('hidden');

        if (checkedService.length) {
          checkedService.forEach(service => {
            if ($(this).data('services').includes(service)) {
              $(this).parent().removeClass('hidden');
            }
          })
        }
        else {
          $(this).parent().removeClass('hidden');
        }

      });

      //Handle lifting 'main_services' to beginning of the list.
      //If only one custom-checkbox is checked, find the lift hide it in the list, copy it to be a big lift.
      //If more than one is checked, make sure to restor their visibility

      //Destroy previous .js-appends
      $('.js-append').remove();

      //Then remake
      if(checkedService.length === 1) {
        //find the needed data from card
        var $card    = $('.cards').find('[data-uuid=' + checkedService + ']');
        var link     = $card.find('a').prop('href');
        var image    = $card.find('.image').prop('style').backgroundImage.replace(/url\("(.*)"\)/, '$1');
        var headline = $card.find('.title span').text();
        var text     = $card.find('.content').text();
        var readMore = $card.find('.secondary-btn span').text();

        //Paste to as first item main list
        var template = $('#mustache-hero').html();

        $('.service-mainlist').prepend(
          Mustache.render(template, {
            'row_classes': 'js-append',
            'link': link,
            'title_image': image,
            'title': headline,
            'ingress': text,
            'read_more_copy': readMore
          })
        );
      } else if(checkedService.length > 1) {
        checkedService.forEach(uuid => {
          const $card = $('.cards').find('[data-uuid=' + uuid + ']').parent();
          $card.removeClass('hidden');
        });
      }

      // Hide heading-between-lines if all cards for this heading are hidden
      $('.cards').each((index, section) => {
        const allCardsHidden = [...section.children].every(card => card.classList.contains('hidden'));
        if (allCardsHidden) {
          section.previousElementSibling.classList.add('hidden');
        } else {
          section.previousElementSibling.classList.remove('hidden')
        }
      })
    }
  }
}

export default serviceList;
